import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import InputWithLabel from "../../components/shared/fields/InputWithLabel";
import Button from "../../components/shared/buttons/button";
import { CiTrash } from "react-icons/ci";
import { FaRegTrashAlt } from "react-icons/fa";

const questionTypes = [
  { value: "text", label: "Text" },
  { value: "number", label: "Number" },
  { value: "singleSelect", label: "Single Select" },
  { value: "multiSelect", label: "Multi Select" },
  { value: "boolean", label: "Yes/No" },
  { value: "date", label: "Date" },
  { value: "range", label: "Range (1-10)" },
  { value: "image", label: "Image" },
  { value: "video", label: "Video" },
  { value: "file", label: "File" },
  { value: "compass", label: "Compass" },
  { value: "spirit", label: "Spirit" },
  { value: "time", label: "Time" },
  { value: "date_and_time", label: "Date and Time" },
];

const QuestionBlock = ({
  q,
  index,
  handleQuestionChange,
  handleOptionChange,
  addOption,
  removeOption,
  removeQuestion,
  questionsLength,
  handleSubQuestionChange,
  addSubQuestion,
  removeSubQuestion,
  isSubQuestion = false,
  handleRangeChange,
  subquestion,
  handleImageChange,
  handleSubQuestionImageChange,
  parentIndex,
}) => {
  console.log(q, "q-->");

  console.log(process.env.REACT_APP_BASE_URL, "BASE URL");

  return (
    <div className={`${isSubQuestion ? "ms-4 mt-3" : ""}`}>

      <div className="d-flex gap-3">
        <div className={`${isSubQuestion ? "subquestion-card" : "question-card "} position-relative flex-grow-1`}>
          <div className="position-absolute end-0 repeatable-card top-0">
            {!isSubQuestion && (
              <div className="d-flex gap-2">
                <Form.Check
                  type="checkbox"
                  label="Compalsury Question"
                  checked={q.isCompulsory}
                  onChange={() => {
                    const newValue = !q.isCompulsory;
                    handleQuestionChange(index, "isCompulsory", newValue);
                  }}
                />
           
                <Form.Check
                  type="checkbox"
                  label="Repeat Question"
                  checked={q.isRepeatable}
                  onChange={() => {
                    const newValue = !q.isRepeatable;
                    handleQuestionChange(index, "isRepeatable", newValue);

                    if (newValue) {
                      // Set question type to number and add only ONE sub-question
                      handleQuestionChange(index, "type", "number");
                      addSubQuestion(index); // This already adds one sub-question
                    } else {
                      handleQuestionChange(index, "subQuestions", []);
                    }
                  }}
                />
                <Form.Check
                  type="checkbox"
                  label="Show comment box"
                  checked={q.showCommentBox}
                  onChange={() => {
                    const newValue = !q.showCommentBox;
                    handleQuestionChange(index, "showCommentBox", newValue);
                  }}
                />
              </div>
            )}
            {isSubQuestion && (
              <div className="d-flex gap-2">
                <Form.Check
                  type="checkbox"
                  label="Compulsory"
                  checked={q.isCompulsory}
                  onChange={() => {
                    const newValue = !q.isCompulsory;
                    handleQuestionChange(index, "isCompulsory", newValue);
                  }}
                />
                <Form.Check
                  type="checkbox"
                  label="Show comment box"
                  checked={q.showCommentBox}
                  onChange={() => {
                    const newValue = !q.showCommentBox;
                    handleQuestionChange(index, "showCommentBox", newValue);
                  }}
                />
              </div>
            )}
          </div>
          <InputWithLabel
            label="Question"
            value={q.text}
            placeholder="Enter your question"
            onChange={(e) =>
              handleQuestionChange(index, "text", e.target.value)
            }
          />


          <Form.Group controlId={`questionType-${index}`}>
            <Form.Label>Question Type</Form.Label>
            <Form.Select
              value={q.type}
              onChange={(e) =>
                handleQuestionChange(index, "type", e.target.value)
              }
              disabled={q.isRepeatable}
            >
              <option value="">Select Type</option>
              {questionTypes.map((type) => (
                <option key={type.value} value={type.value}>
                  {type.label}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          {/* selection  */}
          {(q.type === "singleSelect" ||
            q.type === "multiSelect") && (
              <div className="mb-2">
                <Form.Label>Options</Form.Label>
                {q.options?.map((opt, optIndex) => (
                  <Row key={optIndex} className="mb-2 align-items-centers">
                    <Col>
                      <Form.Control
                        type="text"
                        placeholder={`Option ${optIndex + 1}`}
                        value={opt}
                        onChange={(e) =>
                          handleOptionChange(index, optIndex, e.target.value)
                        }
                      />
                    </Col>
                    <Col xs="auto">
                      {q.options.length > 1 && (
                        <CiTrash className="primary-green" size={24} onClick={() => removeOption(index, optIndex)} />

                      )}
                    </Col>
                  </Row>
                ))}
                <Button
                  size="sm"
                  onClick={() => addOption(index)}
                  label="Add Option"
                  className="mb-2 borderedBtn"
                />
              </div>
            )}

          {q.type === "range" && (
            <div className="mb-2">
              <Row>
                <Col>
                  <InputWithLabel
                    label="Minimum"
                    type="number"
                    value={q.min ?? 1}
                    onChange={(e) =>
                      handleRangeChange(index, "min", parseInt(e.target.value))
                    }
                  />
                </Col>
                <Col>
                  <InputWithLabel
                    label="Maximum"
                    type="number"
                    value={q.max ?? 10}
                    onChange={(e) =>
                      handleRangeChange(index, "max", parseInt(e.target.value))
                    }
                  />
                </Col>
                <Col>
                </Col>
              </Row>
            </div>
          )}
          <InputWithLabel
            className="mt-2"
            label="Image(optional)"
            type="file"
            accept="image/*"
            onChange={(e) => {
              if (isSubQuestion && handleSubQuestionImageChange) {
                handleSubQuestionImageChange(parentIndex, index, e.target.files[0]);
              } else if (!isSubQuestion && handleImageChange) {
                handleImageChange(index, e.target.files[0]);
              }
            }}
          />
          {q.imageFile && (
            <div className="mt-2">
              <small className="text-success">Selected: {q.imageFile.name}</small>
            </div>
          )}
           {q.imageUrl && (
            <div className="mt-2 position-relative d-inline-block">
              <Button
                variant="danger"
                size="sm"
                className="position-absolute top-0 end-0 m-1 p-1"
                
                onClick={() => {
                  if (isSubQuestion) {
                    handleSubQuestionChange(parentIndex, index, "imageUrl", null);
                  } else {
                    handleQuestionChange(index, "imageUrl", null);
                  }
                }}
                icon={<FaRegTrashAlt size={12} />}
              />
             <img src={q.imageUrl} width={100} height={100} className="rounded-2"/>
            </div>
          )}

           <InputWithLabel
            className="mt-2"
            value={q.tooltip}

            label="Tooltip(optional)"
           onChange={(e) =>
              handleQuestionChange(index, "tooltip", e.target.value)
            }
          />
          
          

          {q.isRepeatable &&
            Array.isArray(q.subQuestions) &&
            q.subQuestions.map((subQ, subIdx) => {
              console.log(subQ, "subQ-->");

              // Ensure subQ.options has at least one default option if required
              if (
                ["singleSelect", "multiSelect",].includes(subQ.type) &&
                (!Array.isArray(subQ.options) || subQ.options.length === 0)
              ) {
                subQ.options = [""];
              }

              return (
                <QuestionBlock
                  key={subIdx}
                  q={subQ}
                  index={subIdx}
                  isSubQuestion
                  handleQuestionChange={(i, field, value) =>
                    handleSubQuestionChange(index, subIdx, field, value)
                  }
                  handleOptionChange={(i, optIdx, val) => {
                    const updatedOptions = [...(subQ.options || [])];
                    updatedOptions[optIdx] = val;
                    handleSubQuestionChange(index, subIdx, "options", updatedOptions);
                  }}
                  addOption={() => {
                    const updatedOptions = [...(subQ.options || []), ""];
                    handleSubQuestionChange(index, subIdx, "options", updatedOptions);
                  }}
                  removeOption={(i, optIdx) => {
                    const updatedOptions = (subQ.options || []).filter(
                      (_, i) => i !== optIdx
                    );
                    handleSubQuestionChange(index, subIdx, "options", updatedOptions);
                  }}
                  handleRangeChange={(i, field, val) =>
                    handleSubQuestionChange(index, subIdx, field, val)
                  }
                  removeQuestion={() => removeSubQuestion(index, subIdx)}
                  handleSubQuestionChange={handleSubQuestionChange}
                  addSubQuestion={addSubQuestion}
                  removeSubQuestion={removeSubQuestion}
                  subquestion={q.subQuestions.length}
                  handleImageChange={handleImageChange}
                  handleSubQuestionImageChange={handleSubQuestionImageChange}
                  parentIndex={index}
                />
              );
            })}

          {q.isRepeatable && (
            <div className="mt-3 d-flex justify-content-end">
              <Button onClick={() => addSubQuestion(index)} label={"Add Sub Question"} />
            </div>
          )}
        </div>





        {(questionsLength > 1 || subquestion > 1) && (
          <CiTrash
            className="primary-green"
            size={24}
            onClick={() => removeQuestion(index)}
          />
        )}

      </div>



    </div>
  );
};

export default QuestionBlock;
